/**
 * De lange collectietekst inklappen (sections/collection-long-text.liquid).
 *
 * Zonder JS staat de tekst volledig open. Hier wordt eerst gemeten: past hij al bijna
 * binnen de ingeklapte hoogte, dan geen knop en geen afkapping, want een "Lees verder"
 * dat twee regels oplevert is ruis.
 */

/** Onder deze breedte geldt de mobiele hoogte; de CSS gebruikt dezelfde grens. */
const MOBILE_MAX_WIDTH = 749;

/** Zoveel mag de tekst langer zijn dan de ingeklapte hoogte zonder knop. */
const SLACK = 80;

class CollectionLongText extends HTMLElement {
  connectedCallback() {
    const text = this.querySelector('[data-long-text]');
    const toggle = this.querySelector('[data-long-toggle]');
    if (!(text instanceof HTMLElement) || !(toggle instanceof HTMLButtonElement)) return;

    const mobile = window.innerWidth <= MOBILE_MAX_WIDTH;
    const clamp = Number(mobile ? this.dataset.clampMobile : this.dataset.clamp) || 300;
    if (text.scrollHeight <= clamp + SLACK) return;

    this.style.setProperty('--clamp', `${clamp}px`);
    this.setAttribute('data-clamped', '');
    toggle.hidden = false;

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      this.toggleAttribute('data-clamped', !open);
      toggle.querySelector('[data-long-more]')?.toggleAttribute('hidden', open);
      toggle.querySelector('[data-long-less]')?.toggleAttribute('hidden', !open);
      // Dichtklappen: terug naar het begin van de tekst, anders sta je ineens bij de FAQ.
      if (!open) this.scrollIntoView({ block: 'start' });
    });
  }
}

if (!customElements.get('collection-long-text')) {
  customElements.define('collection-long-text', CollectionLongText);
}
